import {
  Button,
  Columns,
  Container,
  Divider,
  Heading,
  Stack,
  Text,
} from '@spaceship-fspl/components';
import { ExternalRoutes } from '@spaceship-fspl/helpers';
import { SuperProductStarsIcon } from '@spaceship-fspl/icons-web';
import { linearGradient } from '@spaceship-fspl/styles';
import { PanelSection } from 'components';
import { productIcons, SuperPrismicPortfolio } from 'helpers/products';
import React from 'react';
import styled from 'styled-components';

export interface Props {
  portfolio?: SuperPrismicPortfolio;
  title?: string | null;
  tagline?: string | null;
  disclaimer?: string | React.ReactNode;
}

export const SuperSignUpPanel: React.FC<React.PropsWithChildren<Props>> = ({
  portfolio,
  title,
  tagline,
  disclaimer,
}) => {
  const PortfolioIcon = portfolio
    ? productIcons[portfolio]
    : SuperProductStarsIcon;

  return (
    <>
      <Divider color="neutral.050" />
      <StyledPanelSection>
        <Container>
          <Columns alignX="center">
            <Columns.Column width={{ xs: 1, md: 6 / 8, lg: 10 / 12 }}>
              <Stack spaceY="lg" alignX="center">
                <Stack spaceY="md" alignX="center">
                  <PortfolioIcon
                    color="neutral.000"
                    size={{ xs: 'xxxl', lg: 'xxxxl' }}
                  />

                  <Heading
                    component="h2"
                    variant={{ xs: 4, lg: 2 }}
                    color="neutral.000"
                    align="center"
                  >
                    {title}
                  </Heading>
                  {tagline && (
                    <Text
                      variant={{ xs: 2, lg: 1 }}
                      color="neutral.000"
                      align="center"
                    >
                      {tagline}
                    </Text>
                  )}
                </Stack>

                <Button
                  href={ExternalRoutes.SUPER_SIGNUP}
                  size="lg"
                  variant="tertiary"
                >
                  Sign up
                </Button>
                {disclaimer && (
                  <Text
                    variant={3}
                    color="neutral.000"
                    align="center"
                    component="div"
                  >
                    {disclaimer}
                  </Text>
                )}
              </Stack>
            </Columns.Column>
          </Columns>
        </Container>
      </StyledPanelSection>
    </>
  );
};

const StyledPanelSection = styled(PanelSection)`
  background: ${linearGradient({
    angle: '76.52deg',
    colorStops: [
      ['indigo.050', '-39.71%'],
      ['blue.050', '159.62%'],
    ],
  })};
`;
